import axios from "axios";

const axiosClient = axios.create();

axiosClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response?.status === 401) {
            localStorage.removeItem("admToken");
            localStorage.removeItem("user");
            localStorage.removeItem("accessInstance");
            localStorage.removeItem("admAuthStatus");

            window.location.href = "/";
        }

        return Promise.reject(error);
    }
);

export default axiosClient;
